<template>
  <div>
    <van-popup
      round
      v-model="isShow"
      position="bottom"
      :close-on-popstate="true"
    >
      <div class="pad-lr-16">
        <van-panel title="出租车计费标准：">
          <div>
            北京市出租汽车价格调整为3公里以内13元，基本单价每公里2.3元。燃油附加费标准调整为每运次1元。早晚高峰期间低速行驶和等候费为每5分钟加收2公里租价。同时调整预约叫车服务费每次6元。 早高峰为7:00（含）-9:00（不含）；晚高峰为17:00（含）-19:00（不含）。
            23:00—次日5:00每公里租价加收20%费用。
          </div>
          <div slot="footer" />
        </van-panel>
      </div>
      <van-notice-bar
        :text="$t('Q014','温馨提示： 以上信息内容仅供参考，实际情况以各机场公布信息为准')"
        left-icon="volume-o"
      />
    </van-popup>
  </div>
</template>
<script>
import {Popup ,Panel ,NoticeBar } from 'vant'

export default {
  name:'Taxi',
  data() {
    return {
      isShow:false
    }
  },
  components:{
    [Popup.name]:Popup,
    [Panel.name]:Panel,
    [NoticeBar.name]:NoticeBar,
  },
  props:{
    title:{
      type:String,
      default:''
    }
  },
  methods:{
    toggle(){
      this.isShow=!this.isShow
    }
  }
}
</script>
<style lang="less" scoped>
    .pad-lr-16{
        padding:0 16px;
    }
</style>